import { Divider, Stack, Tooltip } from '@mui/material';
import type { RestoreJob } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
import { Icon } from '@/components/shared/icon';
import { useDAL } from '@/contexts/useDAL';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';

import { TableDataPreviewDialog } from '../../db/[id]/TableDataPreviewDialog';
import {
  createObjectUrlLink,
  VisitObjectUrlLinkButton,
} from '../../db/[id]/queryResultsFooter';

export const QueryResultsField = ({ entity }: { entity: RestoreJob }) => {
  const { RecordRestoreResultsEnabled } = useFeatureFlags();
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false);
  const objectUrl = createObjectUrlLink(
    entity.destinationDetails?.restoreResult?.recordRestore?.outputLocations[0]
  );
  if (!objectUrl) {
    return null;
  }

  return (
    <>
      <Stack
        alignItems='center'
        direction='row'
        gap='24px'
        divider={<Divider orientation='vertical' flexItem variant='middle' />}
      >
        {RecordRestoreResultsEnabled && (
          <Tooltip title='Preview sample records'>
            <Icon
              iconClass='material-symbols-visibility-outline-rounded'
              onClick={() => {
                setIsPreviewDialogOpen(true);
              }}
            />
          </Tooltip>
        )}
        <Stack alignItems='center' direction='row' gap='12px'>
          <VisitObjectUrlLinkButton objectUrl={objectUrl} />
          <CopyToClipboardButton
            textToCopy={objectUrl}
            tooltip='Copy object URL'
          />
        </Stack>
      </Stack>
      {isPreviewDialogOpen && (
        <PreviewDialog
          entity={entity}
          setIsPreviewDialogOpen={setIsPreviewDialogOpen}
        />
      )}
    </>
  );
};

const PreviewDialog = ({
  entity,
  setIsPreviewDialogOpen,
}: {
  entity: RestoreJob;
  setIsPreviewDialogOpen: (isOpen: boolean) => void;
}) => {
  const dal = useDAL();

  const { data: results, isLoading } = dal.db.useQueryResults(
    entity.jobExecutionDetails.jobId
  );

  return (
    <TableDataPreviewDialog
      isLoading={isLoading}
      data={{
        headers: results?.columns || [],
        rows: results?.records || [],
      }}
      onClose={() => setIsPreviewDialogOpen(false)}
    />
  );
};
